import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=f2954fe0&"
import script from "./empty.vue?vue&type=script&lang=ts&"
export * from "./empty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AnimateBodyBackground: require('/tmp/build_453bf6d7/src/components/animate/BodyBackground/BodyBackground.vue').default})
